import { BaseApiService } from './BaseApiService';
import { sortById } from './utils';

export class ReportsService extends BaseApiService {
  constructor() {
    super();
    this.api = this.instance;
  }

  async reports(categoryId, yearId, periodId) {
    // GET /api/reports?category_id={category_id}&year_id={year_id}&lang_id={lang_id}

    const { data } = await this.api.get('/reports', {
      params: {
        // lang_id: langId,
        category_id: categoryId,
        year_id: yearId,
        period_id: periodId,
      },
    });

    return {
      data: data.map(x => ({
        id: x.id,
        title: x.title,
        description: x.description,
        cover: {
          src: x.preview_image,
          srcSet: x.preview_image,
        },
        url: x.pdf_path,
        date: x.published_at,
      })),
    };
  }

  async periods() {
    // GET ​/api​/reports​/periods?lang_id={lang_id}

    return this.api.get('/reports/periods', {
      params: {
        // lang_id: langId,
      },
    });
  }

  async categories() {
    // GET ​/api​/reports​/categories?lang_id={lang_id}

    const categoryIconById = {
      1: 'Reports/Raporti i zbatimit të Buxhetit',
      2: 'Reports/Raporti i vështirësive financiare',
      3: 'Reports/Raportet e Kontrollit te Brendshëm Financiar Publik',
    };

    const response = await this.api.get('/reports/categories', { params: {} });

    const data = response.data
      .map(c => ({
        ...c,
        icon: categoryIconById[c.id],
      }))
      .sort(sortById);

    return {
      ...response,
      data,
    };
  }

  async years(categoryId) {
    const { data: items } = await this.api.get('/reports/years', {
      params: {
        category_id: categoryId,
      },
    });

    const data = items.map(item => ({
      value: item.id,
      description: item.year,
    }));

    return { data };
  }
}
